import { enGB } from './en-GB.js';
import { VISITOR_CATALOGUES } from './visitor/index.js';
export { enGB };
export * from './visitor/index.js';
/** Visitor locales hold partial catalogues (visitor keys only); `t()` falls back to en-GB key by key. */
export const LOCALES = { 'en-GB': enGB, ...VISITOR_CATALOGUES };
export const DEFAULT_LOCALE = 'en-GB';
/**
 * Translate a key. Unknown keys return the key itself (so gaps are visible, never crash).
 * `{name}` placeholders are replaced from params. No HTML escaping here: callers rendering HTML must escape.
 */
export function t(key, params, locale = DEFAULT_LOCALE) {
    const messages = LOCALES[locale] ?? enGB;
    const template = messages[key] ?? enGB[key] ?? key;
    if (!params)
        return template;
    return template.replace(/\{(\w+)\}/g, (m, name) => (name in params ? String(params[name]) : m));
}
/** True if the key exists in the en-GB catalogue (used by a test that checks every permission has a label). */
export function hasMessage(key) {
    return key in enGB;
}
//# sourceMappingURL=index.js.map